import { WebcamSourceConfigProvider } from '@/contexts/WebcamSourceConfigContext';
import { createFileRoute } from '@tanstack/react-router'
import { createAuthGuard } from '@/lib/authGuard'

export const Route = createFileRoute('/places/webcam-capture')({
  beforeLoad: createAuthGuard(),
  component: RouteComponent,
})

//TODO: Setup the webcam capture provider and allow capturing that way.
function RouteComponent() {
  return (<WebcamSourceConfigProvider>
        <div>Hello "/places/web-capture"!</div>
    </WebcamSourceConfigProvider>);
}
